import clsx from "clsx";
import { CustomerCardModel } from "../../models";
import { Card, CardBody } from "react-bootstrap";

type Props = {
  payments: CustomerCardModel[];
  onSelect: (payment: CustomerCardModel) => void;
  selected?: boolean;
  selectedCard: CustomerCardModel | undefined;
  onCvvChange: (payment: CustomerCardModel) => void;
};

const PayWithSavedCard: React.FC<Props> = ({
  payments,
  selected,
  selectedCard,
  onCvvChange: handleCvvChange,
  onSelect: handleSavedCardSelection,
}) => {
  const handleCardSelection = (payment: CustomerCardModel) => {
    handleSavedCardSelection(payment);
  };

  return (
    <div className="saved-payments mb-2">
      <div className="mb-2 mx-3 fw-bold">Saved Payment Methods</div>
      {payments.map((payment, index) => (
        <Card
          key={index}
          className={clsx(
            "choose_payment_method_colm",
            selected &&
              selectedCard?.token_uid === payment.token_uid &&
              "payment-method-active",
          )}
        >
          <CardBody className="card_viza card_viza2 flex-column gap-3">
            <label>
              <span>
                <input
                  id={payment.token_uid}
                  type="radio"
                  name="payment_mode"
                  value={payment.token}
                  onClick={() => handleCardSelection(payment)}
                  onChange={() => handleCardSelection(payment)}
                  checked={selectedCard?.token_uid === payment.token_uid}
                />
                <span className="ms-1" style={{ letterSpacing: "2px" }}>
                  {payment.masked_number}
                </span>
              </span>

              <img
                src={payment.image_url}
                className="visa_img"
                height={24}
                alt=""
              />
            </label>

            {selectedCard && selectedCard.token_uid === payment.token_uid && (
              <div className="saved-card-fields">
                <input
                  type="text"
                  placeholder="MM/YY"
                  defaultValue={`${selectedCard?.exp_month}/${selectedCard?.exp_year}`}
                  className="form-control p-2"
                  disabled
                />

                <input
                  type="tel"
                  minLength={3}
                  maxLength={4}
                  placeholder="CVV"
                  value={selectedCard?.cvv}
                  className="form-control p-2"
                  onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleCvvChange({ ...selectedCard, cvv: e.target.value })
                  }
                  required
                />
              </div>
            )}
          </CardBody>
        </Card>
      ))}
    </div>
  );
};

export default PayWithSavedCard;
